<template>
    <div class="centerWidth">
        <!-- <div class="gaokao-nav">
            <span>个人中心 ></span>
            <span>新高考选科测评 ></span>
            <span>开始测试</span>
        </div> -->
        <section class="gaokao-content">
            <div class="my-title">新高考选科测评</div>
            <ul class="gkTest-step">
                <li>
                    <div class="step-con step-on flex zhong center">
                        <div>
                            <img src="../../../image/sub-level-aa.png" />
                            <span>学科水平</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/sub-intl-a.png" />
                            <span>学科兴趣</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/sub-occ-a.png" />
                            <span>职业兴趣</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/sub-char-a.png" />
                            <span>职业性格</span>
                        </div>
                    </div>
                </li>
            </ul>
            <p class="test-tit">学科水平自我评估</p>
            <template v-if="question.length > 0">
                <p
                    class="test-ctxt"
                    :class="{'empty-question': !question[0].notEmpty}"
                >1.{{question[0].Title}}{{question[0].Remark}}</p>
                <div class="test-subject">
                    <div class="flex end">
                        <p class="test-sjRank">排名</p>
                    </div>
                    <ul>
                        <li
                            v-for="(item,index) in sjList"
                            :key="index"
                        >
                            <div class="test-sjImg"><img :src="item.img" /></div>
                            <p class="test-sjTxt">{{item.txt}}</p>
                            <el-select
                                v-model="q1Answer[index]"
                                class="sel-check"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in options1"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
                <p
                    class="test-ctxt"
                    :class="{'empty-question': !question[1].notEmpty}"
                >2.{{question[1].Title}}{{question[1].Remark}}</p>
                <div class="test-sjTable">
                    <div class="sjTable-tit">
                        <p>学科水平</p>
                        <p>对应含义</p>
                    </div>
                    <ul class="sjTable-list">
                        <li
                            v-for="(item,index) in tabList"
                            :key="index"
                        >
                            <p>{{item.tit}}</p>
                            <p>{{item.txt}}</p>
                        </li>
                    </ul>
                </div>
                <div class="test-subject">
                    <div class="flex end">
                        <p class="test-sjRank">排名</p>
                    </div>
                    <ul>
                        <li
                            v-for="(item,index) in sjList"
                            :key="index"
                        >
                            <div class="test-sjImg"><img :src="item.img" /></div>
                            <p class="test-sjTxt">{{item.txt}}</p>
                            <el-select
                                v-model="q2Answer[index]"
                                class="sel-check"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in levelList"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
            </template>
            <button
                class="gaokao-btn"
                @click="goNext()"
            >下一步</button>
        </section>
    </div>
</template>

<script>
const levelList = [{ text: 'A', value: 100 }, { text: 'B+', value: 90 }, { text: 'B', value: 80 }, { text: 'C+', value: 70 }, { text: 'C', value: 60 }, { text: 'D+', value: 50 }, { text: 'D', value: 40 }, { text: 'E', value: 30 }];
export default {
    props: {
        question: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            // 排名
            options1: [
                {
                    value: 1,
                    label: '第一',
                    disabled: false
                },
                {
                    value: 2,
                    label: '第二',
                    disabled: false
                },
                {
                    value: 3,
                    label: '第三',
                    disabled: false
                },
                {
                    value: 4,
                    label: '第四',
                    disabled: false
                },
                {
                    value: 5,
                    label: '第五',
                    disabled: false
                },
                {
                    value: 6,
                    label: '第六',
                    disabled: false
                }
            ],
            options2: [
                {
                    value: 1,
                    label: '第一',
                    disabled: false
                },
                {
                    value: 2,
                    label: '第二',
                    disabled: false
                },
                {
                    value: 3,
                    label: '第三',
                    disabled: false
                },
                {
                    value: 4,
                    label: '第四',
                    disabled: false
                },
                {
                    value: 5,
                    label: '第五',
                    disabled: false
                },
                {
                    value: 6,
                    label: '第六',
                    disabled: false
                }
            ],
            levelList,
            selrank: '',
            // 学科排名
            sjList: [
                {
                    img: require('../../../image/sub-Phy.png'),
                    txt: '物理'
                }, {
                    img: require('../../../image/sub-his.png'),
                    txt: '历史'
                }, {
                    img: require('../../../image/sub-Pol.png'),
                    txt: '政治'
                }, {
                    img: require('../../../image/sub-geo.png'),
                    txt: '地理'
                }, {
                    img: require('../../../image/sub-che.png'),
                    txt: '化学'
                }, {
                    img: require('../../../image/sub-bio.png'),
                    txt: '生物'
                }
            ],
            // 学科水平
            tabList: [
                {
                    tit: 'A',
                    txt: '学科水平出色(-般全校排名为前0 -3%左右)'
                }, {
                    tit: 'B+',
                    txt: '学科水平较好(-般全校排名为前3- 10%左右)'
                }, {
                    tit: 'B',
                    txt: '学科水平良好(一般全校排名为前10 -26%左右)'
                }, {
                    tit: 'C+',
                    txt: '学科水平中等(一般全校排名 为前26 -50%左右)'
                }, {
                    tit: 'C',
                    txt: '学科水平中下(一般全校排名为前50-74%左右)'
                }, {
                    tit: 'D+',
                    txt: '学科水平稍差(-般全校排名为前74-90%左右)'
                }, {
                    tit: 'D',
                    txt: '学科水平较差(-般全校排名为前90-97%左右)'
                }, {
                    tit: 'E',
                    txt: '学科水平不足(-般全校排名为前97- 100%左右)'
                }
            ],
            q1Answer: [1, 2, 3, 4, 5, 6],
            q2Answer: ['', '', '', '', '', '']
        };
    },
    methods: {
        // 下一步
        goNext() {
            if (new Set(this.q1Answer).size !== 6) {
                this.$util.showError('近半年学科存在相同排名');
                return;
            }
            const arr = levelList.map(a => a.value);
            if (this.q2Answer.some(a => !arr.includes(a))) {
                this.$util.showError('有未选择学科等级');
                return;
            }
            this.question[0].Content = this.q1Answer.join(',');
            this.question[1].Content = this.q2Answer.join(',');
            this.$emit('next');
        }
    }
};
</script>

<style scoped>
.test-ctxt.empty-question {
    color: #ff1e00;
    font-weight: bold;
}

.gaokao-nav {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
}
.gaokao-nav span {
    font-size: 15px;
    color: #333;
}
.gaokao-nav span:last-child {
    color: #333;
}
/* gaokao-content */
.gaokao-content {
    padding: 0 20px;
    width: 100%;
    height: auto;
    overflow: hidden;
    background-color: #fff;
    margin-bottom: 25px;
}

.test-tit {
    font-size: 16px;
    color: #333;
    position: relative;
    padding-left: 20px;
    margin-bottom: 30px;
}
.test-tit::after {
    position: absolute;
    content: '';
    width: 0;
    height: 20px;
    left: 0;
    top: 50%;
    margin-top: -10px;
    border: 2px solid #333;
    border-radius: 50px;
}
.test-ctxt {
    font-size: 14px;
    color: #333;
    margin-bottom: 40px;
}
/* test-subject */
.test-subject {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    margin-bottom: 40px;
}
.test-subject ul {
    width: calc(100% - 64px);
    height: auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.test-subject ul li {
    width: calc(100% / 6);
    height: auto;
    overflow: hidden;
}
.test-sjImg {
    width: 100px;
    height: 100px;
    margin: 0 auto;
}
.test-sjImg img {
    width: 100%;
    height: 100%;
    display: block;
}
.test-sjTxt {
    text-align: center;
    font-size: 14px;
    color: #333;
    padding: 20px 0;
}
.test-sjSel {
    position: relative;
    display: flex;
    align-items: center;
}
.test-sjRank {
    width: 64px;
    height: 26px;
    background: url(../../../image/sub-a.png) no-repeat;
    background-size: 100% 100%;
    font-size: 14px;
    color: #de443b;
    text-align: center;
    line-height: 26px;
    margin-bottom: 7px;
}
.sel-check {
    margin: 0 auto;
    width: 100px;
    display: block;
}
/* test-sjTable */
.test-sjTable {
    width: calc(100% - 160px);
    margin: 0 auto;
    border: 1px solid #eee;
    height: auto;
    overflow: hidden;
    margin-bottom: 40px;
}
.sjTable-tit {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #eaeaea;
    height: 60px;
}
.sjTable-tit p {
    font-size: 16px;
    color: #333;
    text-align: center;
}
.sjTable-tit p:first-child {
    width: 30%;
}
.sjTable-tit p:last-child {
    width: 70%;
}
.sjTable-list {
    width: 100%;
    height: auto;
    overflow: hidden;
}
.sjTable-list li {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
}
.sjTable-list li:last-child {
    border-bottom: none;
}
.sjTable-list li p {
    font-size: 16px;
    color: #333;
    text-align: center;
    height: 60px;
    line-height: 60px;
}
.sjTable-list li p:first-child {
    width: 30%;
    border-right: 1px solid #eee;
}
.sjTable-list li p:last-child {
    width: 70%;
}
</style>
